
import Search from 'vux/src/components/search/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'

import configInfo from '../configInfo.js'
import MatchSimple from '../components/league/matchSimple.vue'
import LeagueListHead from '../components/LeagueListHead.vue'
export default {
name: 'app',
created:function(){
this.orgCode = this.$route.query.regionCode;
},
data: function () {
return {
leagueId: null,
leagueName: null,
showLeagueList: false,
content:[],
currentPage:1,
step:5,
orgCode:'',
screenWidth:0,
loading: true,
pulldownConfig:{
downContent: '下拉刷新',
upContent: '释放后更新',
loadingContent: 'Loading...',
},
pullupConfig:{
upContent:'上拉加载更多', downContent: '释放后加载'
},
status2: {
pulldownStatus: 'default',
pullupStatus:'default'
}
}
},
components : {
Badge,
Icon,
Search,
Scroller,
Spinner,
MatchSimple,
LeagueListHead
},
mounted(){

this.$nextTick(() => {
this.$refs.scroller.reset()
this.getData();
this.isUsePullup();
})
this.screenWidth = window.innerWidth;
},
methods:{
changeLeague(leagueId){
this.leagueId = leagueId;
this.getData();
},
getData(){
this.loading = true;

var _this = this;
this.currentPage = 1;
var start = (this.currentPage-1)*this.step;
_this.content.splice(0, _this.content.length);
this.hagkHttp(this.hagkApi.getMatchList(this.orgCode, this.leagueId, start, this.step), {})
.then((res) => {
if (res.status == true) {
var data = res.result;
for(var i=0;i<data.length;i++){
_this.content.push(data[i]);
}
}
_this.$nextTick(() => {
_this.$refs.scroller.reset({top:0})
_this.isUsePullup();
})
this.loading = false;
}, (error) => {
_this.isUsePullup();
console.log(error);
alert('数据获取失败！');
});
},
pulldown(){
var _this = this;
var start = (_this.currentPage-1)*_this.step;
this.hagkHttp(this.hagkApi.getMatchList(this.orgCode, this.leagueId, start, this.step), {})
.then((res) => {
if(res.status == true){
_this.content.splice(0, _this.content.length);
if (res.status == true) {
var data = res.result;
for(var i=0;i<data.length;i++){
_this.content.push(data[i]);
}
}

_this.$refs.scroller.donePulldown();
_this.$nextTick(() => {
_this.$refs.scroller.reset({top:0})
})
this.currentPage = 1;
}
_this.isUsePullup();
}, (error) => {
_this.isUsePullup();
console.log(error)
alert('数据获取失败！');
});
},
pullup(){
var _this = this;
this.currentPage++;
var start = (_this.currentPage-1)*_this.step;
this.hagkHttp(this.hagkApi.getMatchList(this.orgCode, this.leagueId, start, this.step), {})
.then((res) => {
if(res.status == true){
var data = res.result;
if(data.length > 0){
for(var i=0;i<data.length;i++){
_this.content.push(data[i]);
}
} else {
this.currentPage--;
}
}
_this.$refs.scroller.donePullup();
_this.$nextTick(() => {
_this.$refs.scroller.reset()
_this.isUsePullup();
})
}, (error) => {
_this.$refs.scroller.donePullup();
_this.$nextTick(() => {
_this.$refs.scroller.reset()
_this.isUsePullup();
})
console.log(error);
alert('数据获取失败！');
})

},
isUsePullup(){
if(this.content.length>4)
this.$refs.scroller.enablePullup(); 
else
this.$refs.scroller.disablePullup(); 
},
},
computed: {

}
}




// WEBPACK FOOTER //
// ./src/views/matchList.vue